/*
THESIS: Two clear next steps, presented as a progression rather than a SaaS card grid.
OWN-WORLD: Continuous white canvas, dark text, cool-gray rules, and cobalt only for sequence.
STORY: Show the two priorities and how each extends capabilities that already exist.
FIRST VIEWPORT: Navbar, compact title, short introduction, then two open milestones separated by rules.
FORM: Third structure in the internal list, key 3a3a20aa. Mode Read.
*/
import { createFileRoute } from "@tanstack/react-router"
import { PublicNavbar } from "@/components/public-navbar"
import { siteUrl } from "@/lib/seo"

export const Route = createFileRoute("/roadmap")({
  head: () => ({
    meta: [
      { title: "Roadmap | intoshort" },
      {
        name: "description",
        content:
          "See the next product priorities for intoshort: publishing to TikTok and YouTube Shorts, followed by a fuller timeline editor.",
      },
      {
        name: "robots",
        content: siteUrl && import.meta.env.PROD ? "index,follow" : "noindex,follow",
      },
      { property: "og:title", content: "Roadmap | intoshort" },
      {
        property: "og:description",
        content:
          "Two next priorities for intoshort: reliable publishing to TikTok and YouTube Shorts, then a fuller timeline editor.",
      },
      { property: "og:locale", content: "en_US" },
      { property: "og:type", content: "website" },
      ...(siteUrl ? [{ property: "og:url", content: `${siteUrl}/roadmap` }] : []),
    ],
    links: siteUrl ? [{ rel: "canonical", href: `${siteUrl}/roadmap` }] : [],
  }),
  component: RoadmapPage,
})

function RoadmapPage() {
  return (
    <div className="landing roadmap-page">
      <a className="skip-link" href="#roadmap-content">
        Skip to content
      </a>
      <PublicNavbar />
      <main id="roadmap-content" className="page-width roadmap-main">
        <header className="roadmap-intro">
          <p className="roadmap-kicker">What’s next</p>
          <h1>A clear path forward.</h1>
          <p>
            We’re building the next pieces around the workflow already here:
            find the moment, shape the short, and share it.
          </p>
        </header>
        <ol className="roadmap-list">
          <li>
            <span className="roadmap-marker" aria-hidden="true">01</span>
            <div>
              <h2>Publish directly to TikTok and YouTube Shorts</h2>
              <p>
                A reliable publishing flow that brings both destinations
                together. TikTok is already connected; YouTube is implemented
                and still needs production validation.
              </p>
            </div>
          </li>
          <li>
            <span className="roadmap-marker" aria-hidden="true">02</span>
            <div>
              <h2>A full timeline editor</h2>
              <p>
                A more complete editing workspace built on the cuts, captions,
                and sound tools already available, with room for more precise
                control over every short.
              </p>
            </div>
          </li>
        </ol>
      </main>
    </div>
  )
}
